export default "__VITE_ASSET__Bsrts6mq__"